import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api } from '../api.js';
import { useAuth } from '../auth.jsx';
import RichEditor from '../components/RichEditor.jsx';

function fmtDate(s) { return s ? new Date(s.replace(' ', 'T') + 'Z').toLocaleString('ko-KR') : '-'; }

export default function PostDetail({ kind, withComments }) {
  const { id } = useParams();
  const nav = useNavigate();
  const { user } = useAuth();
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentHtml, setCommentHtml] = useState('');

  const load = () => {
    api.getPost(kind, id).then(setPost);
    if (withComments) api.listComments(kind, id).then(setComments);
  };
  useEffect(load, [kind, id, withComments]);

  if (!post) return <div className="p-6 text-medical-500">로딩...</div>;
  const mine = post.created_by === user.id;

  const remove = async () => {
    if (!window.confirm('이 글을 삭제하시겠습니까?')) return;
    try { await api.deletePost(kind, id); nav('/' + kind); } catch (e) { alert(e.message); }
  };
  const submitComment = async () => {
    if (!commentHtml.replace(/<[^>]+>/g, '').trim()) return;
    try { await api.addComment(kind, id, commentHtml); setCommentHtml(''); load(); } catch (e) { alert(e.message); }
  };
  const removeComment = async (c) => {
    if (!window.confirm('댓글을 삭제하시겠습니까?')) return;
    try { await api.deleteComment(kind, id, c.id); load(); } catch (e) { alert(e.message); }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      <div className="bg-white rounded-xl shadow-card border border-medical-100 p-6">
        <div className="text-xs text-medical-500 mb-2">
          <span className="inline-block bg-medical-50 text-medical-700 rounded-full px-2 py-0.5 mr-2">{post.author_institution}</span>
          {post.author_name} · {fmtDate(post.created_at)}
          {post.updated_at && post.updated_at !== post.created_at && <> · (수정: {fmtDate(post.updated_at)})</>}
        </div>
        <h1 className="text-2xl font-bold text-medical-800 mb-4 break-all">{post.title}</h1>
        <div className="prose-readonly" dangerouslySetInnerHTML={{ __html: post.content_html }} />
        <div className="mt-6 flex items-center gap-2">
          <Link to={'/' + kind} className="text-sm text-medical-700 hover:underline">← 목록</Link>
          <span className="ml-auto" />
          {mine && (
            <>
              <Link to={'/' + kind + '/' + id + '/edit'} className="text-sm bg-medical-50 text-medical-700 px-3 py-1.5 rounded-md hover:bg-medical-100">수정</Link>
              <button onClick={remove} className="text-sm bg-red-50 text-red-700 px-3 py-1.5 rounded-md hover:bg-red-100">삭제</button>
            </>
          )}
        </div>
      </div>

      {withComments && (
        <div className="mt-6 bg-white rounded-xl shadow-card border border-medical-100 p-6">
          <h2 className="text-lg font-bold text-medical-800 mb-3">댓글 {comments.length}</h2>
          <div className="space-y-3 mb-5">
            {comments.map(c => (
              <div key={c.id} className="border-b border-medical-50 pb-3">
                <div className="text-xs text-medical-500 mb-1 flex items-center gap-2">
                  <span className="bg-medical-50 text-medical-700 rounded-full px-2 py-0.5">{c.author_institution}</span>
                  <span>{c.author_name}</span>
                  <span>·</span>
                  <span>{fmtDate(c.created_at)}</span>
                  {c.created_by === user.id && (
                    <button onClick={() => removeComment(c)} className="ml-auto text-red-500 hover:underline">삭제</button>
                  )}
                </div>
                <div className="prose-readonly" dangerouslySetInnerHTML={{ __html: c.content_html }} />
              </div>
            ))}
            {comments.length === 0 && <div className="text-medical-400 text-sm">아직 댓글이 없습니다.</div>}
          </div>
          <RichEditor value={commentHtml} onChange={setCommentHtml} placeholder="댓글을 입력하세요" />
          <div className="mt-2 text-right">
            <button onClick={submitComment} className="bg-medical-600 hover:bg-medical-700 text-white text-sm font-semibold px-3 py-1.5 rounded-md">
              댓글 등록
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
